import { useState, useEffect, Fragment } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import HtmlInput from '../../UI/HtmlInput';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import TalkingParrot from '../../../assets/images/talking-parrot.png';
import GoLingo from '../../../assets/images/logo-text.png';
import SuccessBox from '../../UI/SuccessBox';

const EmailConfirm = () => {
  const {t: translate } = useTranslation();
  const { search } = useLocation();
  const history = useHistory();
  const query = new URLSearchParams(search);
  let email = decodeURI(query.get('email'));
  let code = decodeURI(query.get('code')) || '';
  code = code === 'null' ? '' : code;
  email = email === 'null' ? '' : email;
  const confirmFields = {
    email: email,
    confirmationCode: code,
  };
  const [confirmValues, setConfirmValues] = useState(confirmFields);
  const [confirmErrors, setConfirmErrors] = useState({});
  const [apiErrors, setApiErrors] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResetting, setIsRestting] = useState(false);
  const [codeAccepted, setCodeAccepted] = useState(false);
  const { apiUrl } = window['appConfig'];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setConfirmValues({
      ...confirmValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //remove all errors
    setConfirmErrors({});

    if (!confirmValues.email) {
      setConfirmErrors((prevState) => ({
        ...prevState,
        email: translate('email-required'),
      }));
    }

    if (!confirmValues.confirmationCode) {
      setConfirmErrors((prevState) => ({
        ...prevState,
        confirmationCode: translate('confirmation-required'),
      }));
    }

    setIsSubmitting(true);
  };

  const handleCodeConfirmed = () => {
    history.push('/login');
  };

  const submitConfirm = async () => {
    const formData = new URLSearchParams();

    for (const property in confirmValues) {
      formData.append(property, confirmValues[property]);
    }

    const response = await fetch(`${apiUrl}/user/confirm`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    //Confirm failed
    if (data.success !== true) {
      setIsSubmitting(false);
      setApiErrors(data.error);
      return;
    }

    setIsSubmitting(false);
    setCodeAccepted(true);
    // console.log(data);
  };

  const handleResend = async (e) => {
    e.preventDefault();
    setIsRestting(true);

    var url = new URL(`${apiUrl}/user/resendconfirmationcode`);

    var params = { email: confirmValues.email };

    url.search = new URLSearchParams(params).toString();

    fetch(url);

    setTimeout(function () {
      setIsRestting(false);
    }, 1000);
  };

  let content = 
  <Fragment>
    <p className='instructions'>{translate('reset-help-text')}</p>
    <form onSubmit={handleSubmit}>
      <div
        className={`input-row ${
          confirmErrors.email ? 'input-row--error' : ''
        }`}
      >
        <HtmlInput 
          type="email"
          id="email"
          name="email"
          legend={translate('email')}
          value={confirmValues.email}
          changeCallback={handleChange}
          hasErrors={'email' in confirmErrors}
        />
        {confirmErrors.email && (
          <p className="input-row__error">{confirmErrors.email}</p>
        )}
      </div>
      <div
        className={`input-row ${
          confirmErrors.confirmationCode ? 'input-row--error' : ''
        }`}
      >
        <HtmlInput
          type='number'
          id="confirmationCode"
          name="confirmationCode"
          legend={translate('confirmation-code')}
          value={confirmValues.confirmationCode}
          changeCallback={handleChange}
          hasErrors={'confirmationCode' in confirmErrors}
        />
        {confirmErrors.confirmationCode && (
          <p className="input-row__error">{confirmErrors.confirmationCode}</p>
        )}
      </div>
      {apiErrors && <p className="error-field">{apiErrors}</p>}
      <button
        className={`button button--success ${
          isSubmitting ? 'button--loading' : ''
        }`}
        disabled={isSubmitting ? true : false}
      >
        <span>{translate('confirm-code')}</span>
        <FontAwesomeIcon icon={faChevronRight} size="1x" />
      </button>
    </form>
    <button className="button button--alt button--mt-15 button--small" onClick={handleResend}>
      {isResetting
        ? translate('sending-code')
        : translate('resend-code')}
    </button>
  </Fragment>

  useEffect(() => {
    if (Object.keys(confirmErrors).length === 0 && isSubmitting) {
      submitConfirm();
    } else {
      setIsSubmitting(false);
    }
  }, [confirmErrors]);

  return (
    <div className="landing-page">
      <img
        src={TalkingParrot}
        alt={translate('golingo-parrot')}
        title={translate('golingo-parrot')}
        className="parrot"
      />
      <div className="intro-box">
        <p className="intro-text">{translate('welcome-to')}</p>
        <img src={GoLingo} alt="golingo" title="golingo" className="logo" />
      </div>

      <div className="input-container">
        {codeAccepted ? <SuccessBox title={translate('code-accepted')} callback={handleCodeConfirmed} /> : content}
      </div>
    </div>
  );
};

export default EmailConfirm;
